import React, { useState } from 'react';
import {
    Box, Typography, Button, Paper, IconButton, Stack, Dialog,
    DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { toast } from 'react-toastify';

const CustomPdfUpload = ({ values, setFieldValue }) => {
    const [openDialog, setOpenDialog] = useState(false);

    const handleFileChange = (e) => {
          console.log("Selected Files:", e); // 🔍 Check this in console


        const selectedFiles = Array.from(e.target.files).filter(file =>
            file?.name?.endsWith('.pdf')
        );
        console.log("Selected Files:", e); // 🔍 Check this in console

        if (selectedFiles?.length === 0) {
            toast.error('Please upload valid PDF files (.pdf)');
            return;
        }

        const updatedFiles = [...values?.files, ...selectedFiles];
        setFieldValue("files", updatedFiles);
    };

    const handleDownload = (file) => {
        const url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file?.name);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const handleRemoveFile = (indexToRemove) => {
        const updatedFiles = values?.files?.filter((_, idx) => idx !== indexToRemove);
        setFieldValue("files", updatedFiles);
    };

    return (
        <Box>
            {/* Upload Button */}
            <Button
                component="label"
                variant="outlined"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    py: 4,
                    px: 6,
                    borderRadius: 2,
                    borderStyle: 'dashed',
                    borderColor: 'gray',
                    bgcolor: '#fff',
                    cursor: 'pointer',
                    textTransform: 'none',
                    '&:hover': {
                        borderColor: 'primary.main',
                        bgcolor: '#f0f0f0',
                    },
                }}
            >
                <CloudUploadIcon sx={{ fontSize: 80, color: 'var(--main-color)' }} />
                <Typography variant="h6" mt={1}>
                    Upload PDF Files
                </Typography>
                <input
                    type="file"
                    hidden
                    multiple
                    accept=".pdf"
                    onChange={handleFileChange}
                />
            </Button>

            {/* Preview All Button */}
            {values?.files?.length > 0 && (
                <Box mt={2}>
                    <Typography
                        // variant="contained"
                        // startIcon={<VisibilityIcon />}
                        onClick={() => setOpenDialog(true)}
                        sx={{ mb: 2, color: "var(--main-color)", cursor: "pointer" }}
                    >
                        Preview All PDF's
                    </Typography>
                </Box>
            )}

            {/* Dialog for showing all uploaded files */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth scroll="paper">
                <DialogTitle>Uploaded PDF Files</DialogTitle>
                <DialogContent dividers>
                    {values?.files?.map((file, index) => (
                        <Paper key={index} elevation={3} sx={{ p: 2, mb: 2 }}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <InsertDriveFileIcon sx={{ fontSize: 50, color: 'var(--main-color)' }} />
                                <Box flexGrow={1}>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        {file?.name}
                                    </Typography>
                                    <Stack direction="row" spacing={1} mt={1}>
                                        <IconButton color="success" onClick={() => handleDownload(file)}>
                                            <DownloadIcon />
                                        </IconButton>
                                        <IconButton color="error" onClick={() => handleRemoveFile(index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Stack>
                                </Box>
                            </Stack>
                        </Paper>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} variant="outlined">Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default CustomPdfUpload;
